<template>
    <div class="md-detail-info broker" :style="{ marginBottom }">
        <DetailBanner
            :listingDetail="listingDetail"
            :apptTitle="apptTitle"
            :apptSubTitle="apptSubTitle"
            :apptSubmitText="apptSubmitText"
        ></DetailBanner>
        <div class="f-col" ref="detailInfo">
            <div
                class="detail-info-right"
                ref="right"
                :class="{ sold: info.listingStatus == 'Sold' }"
            >
                <Schedule
                    :additionalTitle="additionalTitle"
                    :extData="extData"
                    ref="schedule"
                    v-if="info.listingStatus != 'Sold'"
                    :apptTitle="apptTitle"
                    :apptSubTitle="apptSubTitle"
                    :apptSubmitText="apptSubmitText"
                    :apptQuestionMsg="apptQuestionMsg"
                ></Schedule>
                <GetMoreInfo v-else></GetMoreInfo>
            </div>
            <DetailInfo
                ref="container"
                class="detail-info-left"
                :isapp="false"
                :positionProvidedTop="positionProvidedTop"
                @readMore="onScroll()"
            ></DetailInfo>
        </div>
        <div class="f-col" style="margin-top: 40px">
            <MLS
                :provided="!positionProvidedTop && 'broker'"
                theme="broker"
            ></MLS>
        </div>
        <BottomMenu
            v-if="isMobileSize"
            ref="mobileBottomMenu"
            theme="broker"
            :isOffer="showMakeOffer"
        ></BottomMenu>
        <house-mask v-if="isShowMask" theme="broker" />
        <schema-info :info="seoSchema" v-if="seoSchema" />
    </div>
</template>

<script>
import { mapState } from '@/store/helpers';
import Common from '../index';
import Schedule from '../schedule.vue';
import DetailInfo from './detail-info.vue';
import global from '../../../common/global';
import DetailBanner from './banner.vue';
import BottomMenu from '../bottom-menu.vue';
import GetMoreInfo from './get-more-info.vue';
import MLS from '../mls.vue';
import HouseMask from '../mask.vue';

export default {
    components: {
        Schedule,
        DetailInfo,
        DetailBanner,
        BottomMenu,
        GetMoreInfo,
        MLS,
        HouseMask
    },
    provide() {
        return {
            sharePop: this.sharePop,
            schedulePop: this.schedulePop,
            theme: 'broker',
            styleTheme: 'broker'
        };
    },
    mixins: [Common],
    data: function() {
        return {
            leaveMsgTheme: 'broker',
            additionalTitle: null
        };
    },
    computed: {
        ...mapState({
            "prevAndNext": "prevAndNext"
        }),
        _baseTheme() {
            return 'broker';
        }
    },
    mounted() {
        this.headerHeight = 0;
        this.$root.moduleData.forEach(module => {
            if (module.name == 'md-header' && module.data.sticky) {
                let header = document.querySelector('.md-header');
                this.headerHeight = header ? header.offsetHeight : 0;
            }
        });

        if (this.info.listingStatus == 'Sold') {
            this.offsetTop = 0; 
        } else {
            this.offsetTop = 145; 
        }
        global.scroll(this.onScroll);
    },
    unmounted() {
        global.scroll(this.onScroll, true);
    },
    methods: {
        scrollIntoSchedule() {
            if (this.$refs.schedule) {
                this.$refs.schedule.$el.scrollIntoView();
            }
        },
        onScroll() {
            let right = this.$refs.right;
            if (this.$refs.container.$el.offsetHeight <= right.offsetHeight) {
                if (this.status == 'unactive') {
                    return;
                }
                right.style.position = 'static';
                this.status = 'unactive';
                return;
            }
            let containerRect =
                this.$refs.container.$el.getBoundingClientRect();
            let rightRect = right.getBoundingClientRect();

            if (containerRect.top > this.headerHeight + this.offsetTop) {
                if (this.status == 'normal') {
                    return; 
                }
                right.style.position = 'static';
                this.status = 'normal';
                return;
            }
            if (containerRect.top <= this.headerHeight + this.offsetTop) {
                if (
                    containerRect.bottom >
                    this.headerHeight + right.offsetHeight + this.offsetTop
                ) {
                    if (this.status == 'fixed') {
                        return; 
                    }
                    right.style.position = 'fixed';
                    right.style.left = rightRect.left + 'px';
                    right.style.top = this.headerHeight + this.offsetTop + 'px';
                    right.style.bottom = '';
                    right.style.zIndex = 100;
                    this.status = 'fixed';
                } else {
                    if (this.status == 'bottom') {
                        return; 
                    }
                    right.style.position = 'absolute';
                    right.style.right = '0px';
                    right.style.left = '';
                    right.style.bottom = '0px';
                    right.style.top = 'auto';
                    this.status = 'bottom';
                }
            }
        }
    }
};
</script>
<style lang="scss">
@import '../../../theme/media.scss';

$right-width: 320px;
.md-detail-info.broker {
    position: relative;
    .f-col:not(.breadcrumb-bar) {
        position: relative;
        overflow: visible;
        &:after {
            content: '';
            display: block;
            clear: both;
        }
    }
    .detail-info-right {
        float: right;
        width: $right-width;
        &.sold {
            margin-top: 0px;
        }
        .fixed {
            position: fixed;
            width: $right-width;
        }
        .absolute {
            position: absolute;
            width: $right-width;
        }
    }
    .detail-info-left {
        float: left;
        width: calc(100% - #{$right-width});
        padding-right: 40px;
    }
    @include media-800 {
        margin-top: 0px;
        .detail-info-right {
            display: none;
        }
        .detail-info-left {
            width: 100%;
            padding-right: 0px;
        }
    }
}
</style>
